import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Week from './Week'

const FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6

class Month extends React.Component {
  handleDayClick = (day, event) => {
    if (this.props.onDayClick) {
      this.props.onDayClick(day, event)
    }
  }

  handleDayMouseEnter = day => {
    if (this.props.onDayMouseEnter) {
      this.props.onDayMouseEnter(day)
    }
  }

  handleMouseLeave = () => {
    if (this.props.onMouseLeave) {
      this.props.onMouseLeave()
    }
  }

  isWeekInMonth = startOfWeek => {
    const { day } = this.props
    const endOfWeek = startOfWeek.clone().add(6, 'days')
    return startOfWeek.isSame(day, 'month') || endOfWeek.isSame(day, 'month')
  }

  renderWeeks = () => {
    const weeks = []
    const isFixedHeight = this.props.fixedHeight
    let currentWeekStart = this.props.day
      .clone()
      .startOf('month')
      .startOf('week')
    let i = 0
    let breakAfterNextPush = false

    while (true) {
      weeks.push(
        <Week
          key={i}
          day={currentWeekStart}
          month={this.props.day.month()}
          onDayClick={this.handleDayClick}
          onDayMouseEnter={this.handleDayMouseEnter}
          minDate={this.props.minDate}
          maxDate={this.props.maxDate}
          excludeDates={this.props.excludeDates}
          includeDates={this.props.includeDates}
          inline={this.props.inline}
          highlightDates={this.props.highlightDates}
          selectingDate={this.props.selectingDate}
          filterDate={this.props.filterDate}
          preSelection={this.props.preSelection}
          selected={this.props.selected}
          selectsStart={this.props.selectsStart}
          selectsEnd={this.props.selectsEnd}
          showWeekNumber={this.props.showWeekNumbers}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          utcOffset={this.props.utcOffset}
        />
      )

      if (breakAfterNextPush) break

      i++
      currentWeekStart = currentWeekStart.clone().add(1, 'weeks')

      // If one of these conditions is true, we will either break on this week
      // or break on the next week
      const isFixedAndFinalWeek =
        isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT
      const isNonFixedAndOutOfMonth =
        !isFixedHeight && !this.isWeekInMonth(currentWeekStart)

      if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
        if (this.props.peekNextMonth) {
          breakAfterNextPush = true
        } else {
          break
        }
      }
    }

    return weeks
  }

  getClassNames = () => {
    const { selectingDate, selectsStart, selectsEnd } = this.props
    return classnames('react-datepicker__month', {
      'react-datepicker__month--selecting-range':
        selectingDate && (selectsStart || selectsEnd)
    })
  }

  render () {
    return (
      <div
        className={this.getClassNames()}
        onMouseLeave={this.handleMouseLeave}
        role='listbox'
        tabIndex={0}
      >
        {this.renderWeeks()}
      </div>
    )
  }
}
Month.displayName = 'Month'

Month.propTypes = {
  day: PropTypes.instanceOf(Object).isRequired,
  endDate: PropTypes.instanceOf(Object),
  excludeDates: PropTypes.instanceOf(Array),
  filterDate: PropTypes.func,
  fixedHeight: PropTypes.bool,
  highlightDates: PropTypes.instanceOf(Array),
  includeDates: PropTypes.instanceOf(Array),
  inline: PropTypes.bool,
  maxDate: PropTypes.instanceOf(Object),
  minDate: PropTypes.instanceOf(Object),
  onDayClick: PropTypes.func,
  onDayMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  peekNextMonth: PropTypes.bool,
  preSelection: PropTypes.instanceOf(Object),
  selected: PropTypes.instanceOf(Object),
  selectingDate: PropTypes.instanceOf(Object),
  selectsEnd: PropTypes.bool,
  selectsStart: PropTypes.bool,
  showWeekNumbers: PropTypes.bool,
  startDate: PropTypes.instanceOf(Object),
  utcOffset: PropTypes.number
}

export default Month
